import {useState, useEffect, useMemo} from 'react';
import {reject, generate, findIndex} from 'helpers';
import {Entity} from 'types';

type Item<T extends string> = Entity & Record<T, string>;

export function useEditableList<T extends string>(value: Array<Item<T>>, setValue: (newValue: Array<Item<T>>) => void, key: T) {
  const [id, setId] = useState(generate);

  const reserved = useMemo(() => ({
    id,
    [key]: ''
  } as Item<T>), [id]);

  useEffect(() => {
    if (value && (value.length === 0 || value[value.length - 1][key])) {
      setId(generate);
      setValue([
        ...value,
        reserved
      ]);
    }
  }, [value, reserved]);

  return {
    onKeyDown,
    setValue(fieldValue: string, id: string, fieldKey = key) {
      if (fieldValue || fieldKey !== key) {
        setValue(value.map(item => item.id === id ? {...item, [fieldKey]: fieldValue} : item));
      } else {
        setValue(value.filter(item => item.id !== id));
      }
    }
  };
}

function onKeyDown(event: React.KeyboardEvent) {
  if (event.key === 'Enter') {
    const {target} = event;
    const elements = (target.form || document.body).querySelectorAll('input[type="text"],input[type="password"],textarea');
    const focusable = reject(elements, {tabIndex: -1});
    const next = findIndex(focusable, target) + 1;
    if (focusable[next]) {
      focusable[next].focus();
      event.preventDefault();
    }
  }
}
